import React from "react";

type TextAreaProps = {
  id: string;
  label?: string;
  placeholder?: string;
  value?: string;
  onChangeHandler: (v: string) => void;
  overwriteOnly?: boolean;
  disabled?: boolean;
  required?: boolean;
  invalid?: boolean;
  subtext?: string;
  className?: string;
  rows?: number;
};
const TextArea = ({
  id,
  label,
  placeholder,
  value,
  onChangeHandler,
  overwriteOnly = false,
  disabled = false,
  required = false,
  invalid = false,
  subtext = "",
  className = "",
  rows,
}: TextAreaProps) => {
  const onChange: React.ChangeEventHandler<HTMLTextAreaElement> = (event: React.ChangeEvent<HTMLTextAreaElement>) =>
    onChangeHandler(event.target.value);

  const onBlur: React.FocusEventHandler<HTMLTextAreaElement> = (event: React.FocusEvent<HTMLTextAreaElement>) =>
    onChangeHandler(event.target.value.trim());

  return (
    <div>
      {label && (
        <label htmlFor={id} className="block text-sm font-medium text-gray-700">
          {label}
        </label>
      )}
      <textarea
        className={`
        mt-1 block w-full shadow-sm border-gray-300 disabled:bg-gray-50 disabled:text-gray-500 placeholder:text-gray-400 sm:text-sm rounded-md
        ${
          invalid && value !== "" && value !== undefined
            ? " border-red-500 focus:ring-red-500 focus:border-red-500"
            : " focus:ring-primary-500 focus:border-primary-500"
        } ${
          overwriteOnly
            ? "placeholder:text-current focus:placeholder:placeholder-transparent"
            : "placeholder:text-gray-300"
        } ${className}`}
        name={id}
        id={id}
        rows={rows}
        aria-describedby={subtext ? `${id}-description` : undefined}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        required={required}
      />
      {subtext && (
        <p className="mt-2 text-xs text-gray-400" id={`${id}-description`}>
          {subtext}
        </p>
      )}
    </div>
  );
};

export default TextArea;
